import {useEffect, useRef, useState} from "react"
import {TabsNavigationListContainerBox} from "./boxes/list-container/tabs-navigation-list-container.box"
import {useServices} from "../../react-hooks/use-services.hook"
import {DomEventSubscription} from "../../../utils/event-listener-registration";
import {MenuItemKey} from "../../services/configurations/config-data-sections/generated-config-const";
import {observer} from "mobx-react";
import {CyClass} from "../../../common/cy-classes";
import {TabsNavigationWrapperBox} from "./boxes/wrapper/tabs-navigation-wrapper.box";


interface TabsNavigationIProps {
}

export const TabsNavigationContainer: React.FC<TabsNavigationIProps> = observer((props) => {
    const [shouldRender, setShouldRender] = useState(true);

    const services = useServices();
    const scrollListenerRef = useRef<DomEventSubscription>(null);
    const tabsNavigationBoxRef = useRef<HTMLDivElement>(null);

    const tabsBlocks = services.configuration.data.tabsNavigation.menuLinksBlockOrder;

    useEffect(() => {
        if (!tabsNavigationBoxRef.current) return;

        const tabsNavigationBoxRect = tabsNavigationBoxRef.current.getBoundingClientRect();
        const tabsNabigationBoxHeight = tabsNavigationBoxRect.height;
        const threshold = tabsNabigationBoxHeight || 50;
        let lastScrollY = window.pageYOffset;
        let isTicking = false;

        const updateShouldRender = () => {
            const scrollY = window.pageYOffset;

            if (Math.abs(scrollY - lastScrollY) < threshold) {
                isTicking = false;
                return;
            }

            const updatedShouldRender = scrollY > lastScrollY ? false : true
            setShouldRender(updatedShouldRender);

            lastScrollY = scrollY > 0 ? scrollY : 0;
            isTicking = false;
        };

        const onScroll = () => {
            if (!isTicking) {
                window.requestAnimationFrame(updateShouldRender);
                isTicking = true;
            }
        };

        scrollListenerRef.current = services.window.subscribeTo.scroll(onScroll);

        return () => scrollListenerRef.current.dispose();
    }, [shouldRender, services.window.subscribeTo]);

    const renderTabs = (...menuItemKeys: MenuItemKey[]) => {
        return menuItemKeys.map(menuItemKey => {
            const menuItem = services.tabsNavigation.getMenuItem(menuItemKey);
            return menuItem.renderMenuItem();
        })
    }

    if (!tabsBlocks) {
        return null
    }


    return (
        <TabsNavigationListContainerBox shouldAppear={shouldRender} ref={tabsNavigationBoxRef}>
            <TabsNavigationWrapperBox className={CyClass('cy-tabs-navigation-wrapper')}>
                {tabsBlocks.map(keys => renderTabs(...keys))}
            </TabsNavigationWrapperBox>
        </TabsNavigationListContainerBox>
    )
});